import { render, staticRenderFns } from "./FundsAccountOpen.vue?vue&type=template&id=2955520e&scoped=true&"
import script from "./FundsAccountOpen.vue?vue&type=script&lang=js&"
export * from "./FundsAccountOpen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2955520e",
  null
  
)

export default component.exports